import { useEffect } from "react";
import type { AccountPrice as PointsBalance } from "@b2bportal/hsbc-accounts-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { FiatPrice } from "@hopper-b2b/types";
import { useGetAccountsRewardsQuery, getRewardsAccount } from "../store";

interface UsePointsBalanceResponse {
  rewardsPoints?: PointsBalance;
  cashEquivalent?: FiatPrice;
  formattedPointsBalance: string;
  isLoading: boolean;
  conversionMultiplier?: number;
}

export const usePointsBalance = (
  forceRefetch?: boolean
): UsePointsBalanceResponse => {
  const { data, refetch, isFetching, isLoading } =
    useGetAccountsRewardsQuery(undefined);
  const {
    pointsBalance: rewardsPoints,
    cashEquivalent,
    conversionMultiplier,
  } = getRewardsAccount(data);

  useEffect(() => {
    if (forceRefetch && refetch) {
      refetch();
    }
  }, [forceRefetch, refetch]);

  const { language } = useI18nContext();
  const formattedPointsBalance = new Intl.NumberFormat(language).format(
    rewardsPoints?.value ?? 0
  );

  return {
    rewardsPoints,
    formattedPointsBalance,
    cashEquivalent,
    conversionMultiplier,
    isLoading: isFetching || isLoading,
  };
};
